module.exports = __webpack_public_path__ + "img/Freelance-znak.02c490a.svg";